import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BulkWorkforceGroupShiftGapOverridePreviewQueryCgResponse,
  BulkWorkforceGroupShiftGapOverridePreviewQueryVariables,
} from '@common/graphql/schema';

// Bulk-override Step 2 reads each per-WFG row from this query. The server is
// authoritative for `controlMode` and `disabledReason` so the FE never
// re-derives the control branch from intersection lengths.
export const BULK_WORKFORCE_GROUP_SHIFT_GAP_OVERRIDE_PREVIEW_QUERY: TypedDocumentNode<
  BulkWorkforceGroupShiftGapOverridePreviewQueryCgResponse,
  BulkWorkforceGroupShiftGapOverridePreviewQueryVariables
> = gql`
  query BulkWorkforceGroupShiftGapOverridePreview($shiftGapIds: [ID!]!) {
    bulkWorkforceGroupShiftGapOverridePreview(shiftGapIds: $shiftGapIds) {
      id
      controlMode
      disabledReason
      displayAsLumpSumUniform
      editableGapCount
      nonEditableGapCount
      effectiveRateRangeCents {
        min
        max
      }
      intersectedOptions {
        displayName
        incentiveCents
        moneyAmountCents
      }
      uniformDefault {
        displayName
        incentiveCents
        moneyAmountCents
      }
      workforceGroup {
        id
        name
      }
    }
  }
`;
